import { z } from "zod";

// Presentation metadata only. Net pricing operands and arithmetic are independent.
export const businessMetadataShape = {
  countryCode: z.string().regex(/^[A-Z]{2}$/).nullable().optional(),
  tax: z.object({
    type: z.enum(["vat", "gst", "tax"]).nullable(),
    ratePercent: z.number().finite().nonnegative().nullable(),
  }).strict().nullable().optional(),
};
const businessMetadataSchema = z.object(businessMetadataShape);
export type BusinessMetadata = z.infer<typeof businessMetadataSchema>;

type MonetaryBusiness = BusinessMetadata & { currency: string };
export function sameBusinessMetadata(a: MonetaryBusiness, b: MonetaryBusiness): boolean {
  return a.currency === b.currency &&
    (a.countryCode ?? null) === (b.countryCode ?? null) &&
    (a.tax?.type ?? null) === (b.tax?.type ?? null) &&
    (a.tax?.ratePercent ?? null) === (b.tax?.ratePercent ?? null);
}
export function publishedBusinessMetadata(business: MonetaryBusiness) {
  return { currency: business.currency, countryCode: business.countryCode ?? null, tax: business.tax ?? null };
}
